/**
 * PublicAccessToggleComponent
 *
 * Displays button to enable public access when in VPN mode.
 * Shows loading state during the enable process.
 */

import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { ZuiThreeDotsModule } from '@zerops/zui/three-dots';
import { ZeropsPublicAccess } from '../../zerops-services.model';

@Component({
  selector: 'z-public-access-toggle',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    ZuiThreeDotsModule
  ],
  template: `
    <div class="__public-access-toggle">
      @if (publicAccess()?.mode === 'vpn' && !loading()) {
        <div class="__enable-section">
          <button
            mat-flat-button
            class="c-button--smaller c-button--full"
            (click)="enablePublicAccess.emit()">
            <mat-icon fontSet="material-icons-outlined">public</mat-icon>&nbsp;
            <span>Enable Public Access</span>
          </button>
          <div class="__info">
            <mat-icon fontSet="material-icons-outlined">info</mat-icon>
            <span>Enables browser access with password authentication</span>
          </div>
        </div>
      } @else if (loading()) {
        <div class="__loading">
          <button
            mat-flat-button
            class="c-button--smaller c-button--full"
            disabled>
            <zui-three-dots />
            <span>Setting up...</span>
          </button>
        </div>
      }
    </div>
  `,
  styleUrl: './public-access-toggle.component.scss'
})
export class PublicAccessToggleComponent {
  publicAccess = input<ZeropsPublicAccess | null>();
  loading = input<boolean>(false);
  enablePublicAccess = output<void>();
}
